<era-pane>
  <form [formGroup]="modelsSetPerSettingForm">
    <div class="d-flex">
      <h5 class="mt-auto small-caps">{{ matrixOptions().settingsTableHeader }}</h5>
      @if (allowEdit() && !editing) {
        <button type="button"
                class="btn btn-sm btn-outline-primary border-0 ms-auto"
                data-testid="selection-matrix-edit-button"
                (click)="edit()">
          <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
        </button>
      }
      @if (editing) {
        <div class="ms-auto">
          <button type="button"
                  class="btn btn-outline-primary border-0"
                  data-testid="selection-matrix-save-button"
                  (click)="save()">
            <fa-icon [icon]="['far', 'save']"></fa-icon>
          </button>
          <button type="button"
                  class="btn btn-sm btn-outline-secondary border-0"
                  (click)="cancel()">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
          </button>
        </div>
      }
    </div>
    <table class="table">
      <thead class="small-caps">
        <tr>
          <th class="header-group"
              [attr.colspan]="matrixOptions().settingsSecondColumnHeader ? 2 : 1">
            <div class="header-content">
              <div>{{ matrixOptions().settingsFirstColumnHeader }}</div>
              @if (matrixOptions().settingsSecondColumnHeader) {
                <div>
                  {{ matrixOptions().settingsSecondColumnHeader }}
                </div>
              }
            </div>
          </th>
          <th class="text-center"
              [style.visibility]="matrixOptions().displayedModels.includes('AppleTV') ? 'inherit' : 'hidden'">
            Apple TV
          </th>
          <th class="text-center"
              [style.visibility]="matrixOptions().displayedModels.includes('iPad') ? 'inherit' : 'hidden'">
            iPad
          </th>
          <th class="text-center"
              [style.visibility]="matrixOptions().displayedModels.includes('iPhone') ? 'inherit' : 'hidden'">
            iPhone
          </th>
          <th class="text-center"
              [style.visibility]="matrixOptions().displayedModels.includes('iPod') ? 'inherit' : 'hidden'">
            iPod
          </th>
          @if (!editing) {
            <th class="text-center">inherited</th>
          }
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (row of localModelsSetPerSetting | keyvalue; track row; let last = $last) {
          <tr data-testid="selection-matrix-data-row">
            <td class="header-group"
                [attr.colspan]="matrixOptions().settingsSecondColumnHeader ? 2 : 1">
              <div class="header-content">
                <div>{{ row.value.displayName }}</div>
                @if (matrixOptions().settingsSecondColumnHeader) {
                  <div>
                    {{ row.value.displayNameString }}
                  </div>
                }
              </div>
            </td>
            <td class="text-center"
                [style.visibility]="matrixOptions().displayedModels.includes('AppleTV') ? 'inherit' : 'hidden'">
              @if (!editing) {
                <ml-yes-no-icon [flag]="row.value['AppleTV']"></ml-yes-no-icon>
              } @else if (editing && matrixOptions().allowMultiple) {
                <input formControlName="{{ row.key }}_AppleTV"
                       id="{{ row.key }}_AppleTV"
                       type="checkbox" />
              } @else if (editing && !matrixOptions().allowMultiple) {
                <input formControlName="AppleTV"
                       id="AppleTV"
                       type="radio"
                       value="{{ row.key }}"
                       [attr.data-testid]="last ? 'selection-matrix-last-row-appletv-radio' : null" />
              }
            </td>
            <td class="text-center"
                [style.visibility]="matrixOptions().displayedModels.includes('iPad') ? 'inherit' : 'hidden'">
              @if (!editing) {
                <ml-yes-no-icon [flag]="row.value['iPad']"></ml-yes-no-icon>
              } @else if (editing && matrixOptions().allowMultiple) {
                <input formControlName="{{ row.key }}_iPad"
                       id="{{ row.key }}_iPad"
                       type="checkbox" />
              } @else if (editing && !matrixOptions().allowMultiple) {
                <input formControlName="iPad"
                       id="iPad"
                       type="radio"
                       value="{{ row.key }}"
                       [attr.data-testid]="last ? 'selection-matrix-last-row-ipad-radio' : null" />
              }
            </td>
            <td class="text-center"
                [style.visibility]="matrixOptions().displayedModels.includes('iPhone') ? 'inherit' : 'hidden'">
              @if (!editing) {
                <ml-yes-no-icon [flag]="row.value['iPhone']"></ml-yes-no-icon>
              } @else if (editing && matrixOptions().allowMultiple) {
                <input formControlName="{{ row.key }}_iPhone"
                       id="{{ row.key }}_iPhone"
                       type="checkbox" />
              } @else if (editing && !matrixOptions().allowMultiple) {
                <input formControlName="iPhone"
                       id="iPhone"
                       type="radio"
                       value="{{ row.key }}"
                       [attr.data-testid]="last ? 'selection-matrix-last-row-iphone-radio' : null" />
              }
            </td>
            <td class="text-center"
                [style.visibility]="matrixOptions().displayedModels.includes('iPod') ? 'inherit' : 'hidden'">
              @if (!editing) {
                <ml-yes-no-icon [flag]="row.value['iPod']"></ml-yes-no-icon>
              } @else if (editing && matrixOptions().allowMultiple) {
                <input formControlName="{{ row.key }}_iPod"
                       id="{{ row.key }}_iPod"
                       type="checkbox" />
              } @else if (editing && !matrixOptions().allowMultiple) {
                <input formControlName="iPod"
                       id="iPod"
                       type="radio"
                       value="{{ row.key }}"
                       [attr.data-testid]="last ? 'selection-matrix-last-row-ipod-radio' : null" />
              }
            </td>
            @if (!editing) {
              <td class="text-center">
                @if (!!row.value.categoryId && row.value.categoryType && row.value.categoryType !== currentLevel()) {
                  <div>
                    {{ row.value.categoryType.toLowerCase() }}
                  </div>
                }
              </td>
            } @else {
              <td>
                <button type="button"
                        class="btn btn-outline-danger border-0 ms-auto"
                        (click)="delete(row)">
                  <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                </button>
              </td>
            }
          </tr>
        }
        @if (editing) {
          <tr class="add-row">
            <th class="small-caps pt-3">add</th>
          </tr>

          <tr class="add-row">
            <td>
              <div class="input-group">
                <select class="form-select"
                        formControlName="setting"
                        data-testid="selection-matrix-profile-select">
                  @for (setting of modelsSetPerSetting() | keyvalue; track setting) {
                    <option [ngValue]="setting"
                            [hidden]="localModelsSetPerSetting[setting.key] !== undefined">
                      {{ setting.value.displayName }}
                    </option>
                  }
                </select>
              </div>
            </td>
            <td>
              <button type="button"
                      class="btn btn-outline-success"
                      data-testid="selection-matrix-add-button"
                      (click)="add()">
                <fa-icon [icon]="['fas', 'plus']"></fa-icon>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </form>
</era-pane>